<div class="p-6 w-full">
  <!-- BreadCrumb -->
  <div class="header-section">
    <nav class="inter flex items-center space-x-2 text-sm text-gray-700 mb-4">
      <span class="material-symbols-outlined" style="font-size: 18px"
        >home</span
      >
      <span
        class="text-[14px] font-medium color-[#374151] cursor-pointer"
        (click)="navigateToMenu()"
        >Home</span
      >
      <span class="material-symbols-outlined text-[#6B7280]"
        >arrow_forward_ios</span
      >
      <span class="text-[14px] font-medium color-[#374151]"
        >Configuración de Perfiles</span
      >
    </nav>
    <h1 class="text-[28px] font-medium text-black w-fit">
      Configuración de Perfiles
    </h1>
  </div>
  <!-- w-[calc(100vw-60px)]! sm:w-[calc(100vw-314px)]! -->
  <div class="flex flex-col lg:flex-row lg:justify-between lg:items-center">
    <div class="md:w-64 mt-8 mb-4">
      <app-custom-search
        placeholder="Buscar"
        backgroundColor="#ffffff"
        textColor="#374151"
        iconColor="#9ca3af"
        borderColor="#e1e5e9"
        focusBorderColor="#3b82f6"
        [showClearButton]="false"
        (keyup)="onSearchKeyup($event)"
      />
    </div>
    <!-- Botones de acción -->
    <div class="flex flex-col md:flex-row gap-3 lg:mt-6 mb-4 lg:mb-0">
      <!-- Botón Exportar Excel -->
      <app-custom-button
        text="Exportar excel"
        backgroundColor="#5CA42F"
        borderColor="#5CA42F"
        size="md"
        icon='<span class="material-symbols-outlined text-[17px]">file_save</span>'
        iconPosition="left"
        hoverBackgroundColor="#487F25"
        hoverTextColor="#ffffff"
        (click)="exportTable($event)"
      >
      </app-custom-button>

      <!-- Botón Agregar Usuario -->
      <app-custom-button
        text="Agregar nuevo Perfil"
        backgroundColor="#005FFF"
        borderColor="#005FFF"
        size="md"
        icon='<span class="material-symbols-outlined text-[20px]">add</span>'
        iconPosition="left"
        hoverBackgroundColor="#0549BD"
        hoverTextColor="#ffffff"
        (click)="openModal()"
      >
      </app-custom-button>
    </div>
  </div>

  <!-- Tabla -->
  <mat-card>
    <mat-card-content class="!p-0">
      <div class="flex-1 overflow-x-auto!">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="codigo">
            <th
              class="min-w-[170px] w-[170px]"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              CÓDIGO
            </th>
            <td mat-cell *matCellDef="let element">
              <app-custom-tooltip text="{{ element.codigo }}" position="below">
                {{ element.codigo }}
              </app-custom-tooltip>
            </td>
          </ng-container>

          <ng-container matColumnDef="nombre">
            <th
              class="min-w-[170px] w-[170px]"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              NOMBRE
            </th>
            <td mat-cell *matCellDef="let element">
              <app-custom-tooltip text="{{ element.nombre }}" position="below">
                {{ element.nombre }}
              </app-custom-tooltip>
            </td>
          </ng-container>

          <ng-container matColumnDef="sistemas">
            <th
              class="min-w-[170px] w-[170px]"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              SISTEMA
            </th>
            <td mat-cell *matCellDef="let element" class="whitespace-normal!">
              <app-custom-tooltip
                text="{{ getSisLabel(element) }}"
                position="below"
              >
                {{
                  element.sistemas.length > 0 ? element.sistemas[0].nombre : ""
                }}
                @if (getCantSis(element) > 1) {
                <ng-container>
                  <label
                    data-toggle="tooltip"
                    data-placement="right"
                    [title]="getSisLabel(element)"
                  >
                    (+{{ getCantSis(element) - 1 }}
                    {{ getCantSis(element) === 2 ? "otro" : "otros" }})
                  </label>
                </ng-container>
                }
              </app-custom-tooltip>
            </td>
          </ng-container>
          <ng-container matColumnDef="menus">
            <th
              class="min-w-[170px] w-[170px]"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              MENÚS
            </th>
            <td mat-cell *matCellDef="let element" class="whitespace-normal!">
              <app-custom-tooltip
                text="{{ getMenuLabel(element) }}"
                position="below"
              >
                {{ element.menus.length > 0 ? element.menus[0].titulo : "" }}
                @if (getCantMenu(element) > 1) {
                <ng-container>
                  <label data-toggle="tooltip" data-placement="right">
                    (+{{ getCantMenu(element) - 1 }}
                    {{ getCantMenu(element) === 2 ? "otro" : "otros" }})
                  </label>
                </ng-container>
                }
              </app-custom-tooltip>
            </td>
          </ng-container>
          <ng-container matColumnDef="puertas">
            <th
              class="min-w-[170px] w-[170px]"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              PUERTAS
            </th>
            <td mat-cell *matCellDef="let element">
              <app-custom-tooltip text="{{ element.puertas }}" position="below">
                {{ element.puertas }}
              </app-custom-tooltip>
            </td>
          </ng-container>

          <ng-container matColumnDef="accion">
            <th class="w-[70px]" mat-header-cell *matHeaderCellDef>EDITAR</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button (click)="openEditModal(element)">
                <span
                  class="material-symbols-outlined"
                  style="
                    font-size: 18px;
                    font-variation-settings: 'opsz' 18;
                    color: #6b7280;
                  "
                >
                  edit_square
                </span>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <mat-paginator
        class="pt-3! border-t border-gray-300!"
        [pageSizeOptions]="[10, 25, 100]"
        [showFirstLastButtons]="false"
      ></mat-paginator> </mat-card-content
  ></mat-card>
</div>

<!-- Modal Agregar Usuario -->
<app-custom-modal
  [isOpen]="isOpenModal"
  [title]="editMode ? 'Editar Perfil' : 'Agregar Perfil'"
  size="md"
  [buttons]="editMode ? editProfileButtons : addProfileButtons"
  (close)="closeModal()"
  (buttonClick)="submitProfileForm()"
>
  <form [formGroup]="profileForm" (ngSubmit)="submitProfileForm()">
    <div class="mb-4">
      <app-input-custom
        label="Nombre Perfil"
        formControlName="nombre"
        [hasError]="nombreInput?.errors?.['required'] && nombreInput?.touched"
        [maxLength]="50"
      />

      @if (nombreInput?.errors?.['required'] && nombreInput?.touched) {
      <p class="text-red-600 text-sm font-normal ml-1">Nombre obligatorio.</p>
      }
    </div>
    <div class="mb-4">
      <app-input-custom
        label="Código"
        formControlName="codigo"
        [hasError]="codigoInput?.errors?.['required'] && codigoInput?.touched"
        [maxLength]="50"
      />
      @if (codigoInput?.errors?.['required'] && codigoInput?.touched) {
      <p class="text-red-600 text-sm font-normal ml-1">Código obligatorio.</p>
      }
    </div>
    <div class="mb-4">
      <div
        class="border {{ menusInput?.errors?.['required'] && menusInput?.touched ? 'border-red-600' : 'border-[#E4E9EF]' }} rounded-md"
      >
        <mat-form-field class="custom-field w-full p-0!">
          <mat-label>Menu </mat-label>
          <mat-select
            formControlName="menus"
            multiple
            [compareWith]="compareMenus"
          >
            @for (menuItem of menus; track menuItem.codigoMenu) {
            <mat-option [value]="menuItem">{{ menuItem.titulo }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (menusInput?.errors?.['required'] && menusInput?.touched) {
      <p class="text-red-600 text-sm font-normal ml-1">Menú obligatorio.</p>
      }
    </div>
    <div class="mb-4">
      <div
        class="border {{ sistemasInput?.errors?.['required'] && sistemasInput?.touched ? 'border-red-600' : 'border-[#E4E9EF]' }} rounded-md"
      >
        <mat-form-field class="custom-field w-full p-0!">
          <mat-label>Sistemas </mat-label>
          <mat-select
            formControlName="sistemas"
            multiple
            [compareWith]="compareSistemas"
          >
            @for (systemItem of sistemas; track systemItem.id) {
            <mat-option [value]="systemItem">{{
              systemItem.nombre
            }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (sistemasInput?.errors?.['required'] && sistemasInput?.touched) {
      <p class="text-red-600 text-sm font-normal ml-1">Sistema obligatorio.</p>
      }
    </div>
  </form>
</app-custom-modal>
